"use client"

import NextLink from "next/link"
import { usePathname } from "next/navigation"

const options = [
  { name: "Privacy Policy", path: "/privacy-policy" },
  { name: "Terms of Service", path: "/terms" },
  { name: "Help & Support", path: "/support" },
  { name: "DMCA Policy", path: "/dmca-policy" },
  { name: "Community Guidelines", path: "/community-guidelines" },
]

const SideMenu = () => {
  const path = usePathname()

  return (
    <div className="sticky top-[250px] hidden w-1/4 min-w-[250px] flex-col items-start gap-y-4 sm:flex md:ml-5">
      {options.map((option, index) => (
        <NextLink
          key={index}
          href={option.path}
          className={` ${path === option.path ? "text-fg-inverse" : "text-[#FFFFFF59]"}`}>
          {option.name}
        </NextLink>
      ))}
    </div>
  )
}

export default SideMenu
